import { post, get } from '../helpers/fetchServicesMethods';
import { url } from '../reducers/url';
import PubSub from 'pubsub-js';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

/**
 * Share one saved view.
 *
 * @param viewName name as it appears in Saved Views
 * @param view     the single view payload out of fieldConfig.views
 * @param scope    'members' or 'entity'
 * @param userIds  gq_user ids, for scope 'members' only
 */
async function shareView(viewName, view, scope, userIds) {
    // The column template is far too big for a query string, so it goes in the body.
    const postData = {
        'do': 'gqsharedview.share',
        'viewname': viewName,
        'scope': scope,
        'usr': (userIds || []).join(','),
        'view': view
    };

    try {
        showLoader();
        return await post(url.shareView, postData)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        hideLoader();
        console.error(error, "errors");
    }
}

/**
 * Push the current payload of an already shared view to its recipients.
 * A no-op server side when the view was never shared.
 */
async function refreshSharedView(viewName, view) {
    const postData = {
        'do': 'gqsharedview.refresh',
        'viewname': viewName,
        'view': view
    };

    try {
        return await post(url.refreshSharedView, postData)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error, "errors");
    }
}

/**
 * The owner renamed a shared view - move the share to the new name rather than
 * leaving recipients on the old one with stale content.
 */
async function renameSharedView(oldName, newName, view) {
    const postData = {
        'do': 'gqsharedview.rename',
        'oldname': oldName,
        'viewname': newName,
        'view': view
    };

    try {
        return await post(url.renameSharedView, postData)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error, "errors");
    }
}

async function unshareView(viewName) {
    try {
        let apiurl = url.unshareView;
        apiurl = apiurl.replace(':viewname:', encodeURIComponent(viewName));

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        hideLoader();
        console.error(error, "errors");
    }
}

async function removeRecipient(viewName, receiverId) {
    try {
        let apiurl = url.removeSharedViewRecipient;
        apiurl = apiurl.replace(':viewname:', encodeURIComponent(viewName));
        apiurl = apiurl.replace(':receiver:', receiverId);

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        hideLoader();
        console.error(error, "errors");
    }
}

/**
 * Colleagues this view can be shared with, and which of them already have it.
 *
 * Deliberately not ftAccess.shareableList: that roster is scoped to a workflow and
 * drops anyone the workflow is already shared with, so sharing results with someone
 * would make them vanish from the view picker.
 */
async function shareableUsers(viewName) {
    try {
        let apiurl = url.shareableViewUsers;
        apiurl = apiurl.replace(':viewname:', encodeURIComponent(viewName || ''));

        return await get(apiurl)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error, "errors");
    }
}

/**
 * Views other people have shared with the current user.
 * Loaded alongside the user's own preferences, never written into them.
 */
async function sharedWithMe() {
    try {
        return await get(url.viewsSharedWithMe)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error, "errors");
    }
}

/**
 * Views the current user has shared, and who each one reaches.
 */
async function sharedByMe() {
    try {
        return await get(url.viewsSharedByMe)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error, "errors");
    }
}

const sharedViews = {
    shareView,
    shareableUsers,
    renameSharedView,
    refreshSharedView,
    unshareView,
    removeRecipient,
    sharedWithMe,
    sharedByMe
};

export default sharedViews;
